import { useEffect, useRef } from "react";
import { hasSeenAuroraTour, startAuroraTour, waitForTourTargets } from "../lib/auroraTour";

/**
 * Inicia un tour Shepherd una sola vez (localStorage) cuando `enabled` es true.
 */
export function useAuroraTour(storageKey, steps, { enabled = true, delay = 700 } = {}) {
  const startedRef = useRef(false);

  useEffect(() => {
    if (!enabled || !storageKey || !steps?.length || startedRef.current) return;
    if (hasSeenAuroraTour(storageKey)) return;

    let cancelled = false;
    const selectors = steps.map((s) => s.attachTo?.element).filter(Boolean);

    const timer = window.setTimeout(async () => {
      if (cancelled || startedRef.current) return;
      await waitForTourTargets(selectors);
      if (cancelled || startedRef.current) return;
      if (hasSeenAuroraTour(storageKey)) return;

      const firstRequired = selectors[0];
      if (firstRequired && !document.querySelector(firstRequired)) return;

      startedRef.current = true;
      startAuroraTour({ storageKey, steps });
    }, delay);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [storageKey, enabled, delay, steps]);
}
